import { useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ModalActions from 'Redux/ModalRedux'
import { defaultFlags } from 'Utils/launch-darkly-flags'

export function useHelpMenu () {
  const dispatch = useDispatch()

return useMemo(() => ({
  openOssTerms: () => {
    if (defaultFlags.ossAgreementVerification) {
      dispatch(ModalActions.modalOpen('ossTermsV2'));
    } else {
      dispatch(ModalActions.modalOpen('ossTerms'));
    }
  }
}), [dispatch, defaultFlags.ossAgreementVerification]); // Note: Add any dependencies that change `useMemo`'s behavior.

}
